const CONSTANTS = {
  PRODUCT_FORM_SELECTOR: '[data-product-form]',
  PRODUCT_OPTION_SELECT_SELECTOR: '[data-option-select]',
  PRODUCT_MAIN_IMAGE_SELECTOR: '[data-main-product-image]',
  PRODUCT_VARIANT_ID_FORM_FIELD: '[data-product-form] [name="id"]',
  PRODUCT_IMAGE_THUMBS_SELECTOR: '[data-product-thumbnail-index]',
  PRODUCT_IMAGE_THUMBS_ATTR: 'data-product-thumbnail-index',
  PRODUCT_THUMBNAIL_ACTIVE_CLASS: 'active',
  PRODUCT_STOCK_WRAPPER_ATTR: 'data-product-in-stock',
  PRODUCT_OOS_TEXT_ATTR: 'data-oos-text',
  PRODUCT_PRE_ORDER_TEXT_ATTR: 'data-preorder-text',
  PRODUCT_IN_STOCK_TEXT_ATTR: 'data-in-stock-text',
  PRODUCT_UNAVAILABLE_TEXT_ATTR: 'data-unavailable-text',
  PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR: '[data-product-form-submit]',
  PRODUCT_PRICE_SELECTOR: '[data-product-price]',
  PRODUCT_SUB_SAVING_PRICE_SELECTOR: '[data-product-subscription-saving-price]',
  PRODUCT_COMPARE_AT_PRICE_SELECTOR: '[data-product-compare-at-price]',
  PRODUCT_STOCK_MAP: 'data-product-stock-map'
}

export default CONSTANTS;